export default __webpack_public_path__ + "static/media/bp-17.4711c38a.jpg";